<template>
  <div class="c-template-table table-responsive c-role-table c-draggable-table">
    <table class="table table-hover">
      <thead>
      <tr>
        <th>{{ $t('constraint') }}</th>
        <th>{{ $t('from') }}</th>
        <th>{{ $t('to') }}</th>
        <th></th>
      </tr>
      </thead>
      <tbody v-if="values && values.length">
      <tr v-for="(item, index) in values" :key="item.key">
        <td>{{ getType(item.type) }}</td>
        <td>
          <span v-if="['mon','mday'].includes(item.type)">{{ item.from }}</span>
          <span v-else>{{ $t(item.from) }}</span>
        </td>
        <td>
          <span v-if="['mon','mday'].includes(item.type)">{{ item.to }}</span>
          <span v-else>{{ $t(item.to) }}</span>
        </td>
        <td>
          <button class="btn btn-sm btn-outline-gray mr-1" @click="removeCondition(index)">
            <i class="icon12-delete-primary"></i></button>
        </td>
      </tr>
      </tbody>
      <tbody v-else>
      <tr>
        <td colspan="4" class="text-center" :class="checkConditionCount ? 'text-danger' : ''">
          {{ $t('noConditionSetUp') }}
        </td>
      </tr>
      </tbody>
      <tbody>
      <tr>
        <td>
          <form-select :model="formModel" attribute="type" :options="typeOptions" :errors="formErrors"></form-select>
        </td>
        <td>
          <form-select :disabled="!formModel.type" :model="formModel" attribute="from" :options="getOptions" :errors="formErrors"></form-select>
        </td>
        <td>
          <form-select :disabled="!formModel.type" :model="formModel" attribute="to" :options="getOptions" :errors="formErrors"></form-select>
        </td>
        <td>
          <button class="btn btn-sm btn-primary mb-3" @click="addCondition">{{ $t('addCondition') }}</button>
        </td>
      </tr>
      </tbody>
    </table>
    <div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['model', 'errors'],
  data: function () {
    return {
      formModel: {
        type: null,
        from: null,
        to: null
      },
      values: [],
      formErrors: [],
      typeOptions: [
        {value: null, text: this.$t('chooseConditionType')},
        {value: 'mon', text: this.$t('month')},
        {value: 'mday', text: this.$t('dayInMonth')},
        {value: 'wday', text: this.$t('dayInWeek')},
        {value: 'time-of-day', text: this.$t('timeOfDay')},
      ],
      monthOptions: [
        {value: null, text: this.$t('chooseMonth')},
        {value: '1', text: this.$t('jan')},
        {value: '2', text: this.$t('feb')},
        {value: '3', text: this.$t('mar')},
        {value: '4', text: this.$t('apr')},
        {value: '5', text: this.$t('may')},
        {value: '6', text: this.$t('jun')},
        {value: '7', text: this.$t('jul')},
        {value: '8', text: this.$t('aug')},
        {value: '9', text: this.$t('sep')},
        {value: '10', text: this.$t('oct')},
        {value: '11', text: this.$t('nov')},
        {value: '12', text: this.$t('dec')},
      ],
      mDayOptions: [
        {value: null, text: this.$t('chooseMDay')},
        {value: '1', text: 1},
        {value: '2', text: 2},
        {value: '3', text: 3},
        {value: '4', text: 4},
        {value: '5', text: 5},
        {value: '6', text: 6},
        {value: '7', text: 7},
        {value: '8', text: 8},
        {value: '9', text: 9},
        {value: '10', text: 10},
        {value: '11', text: 11},
        {value: '12', text: 12},
        {value: '13', text: 13},
        {value: '14', text: 14},
        {value: '15', text: 15},
        {value: '16', text: 16},
        {value: '17', text: 17},
        {value: '18', text: 18},
        {value: '19', text: 19},
        {value: '20', text: 20},
        {value: '21', text: 21},
        {value: '22', text: 22},
        {value: '23', text: 23},
        {value: '24', text: 24},
        {value: '25', text: 25},
        {value: '26', text: 26},
        {value: '27', text: 27},
        {value: '28', text: 28},
        {value: '29', text: 29},
        {value: '30', text: 30},
        {value: '31', text: 31},
      ],
      wDayOptions: [
        {value: null, text: this.$t('chooseWDay')},
        {value: 'mon', text: this.$t('mon')},
        {value: 'tue', text: this.$t('tue')},
        {value: 'wed', text: this.$t('wed')},
        {value: 'thu', text: this.$t('thu')},
        {value: 'fri', text: this.$t('fri')},
        {value: 'sat', text: this.$t('sat')},
        {value: 'sun', text: this.$t('sun')},
      ],
      timeOfDayOptions: [
        {value: null, text: this.$t('chooseTimeOfDay')},
        {value: '00:00', text: '00:00'},
        {value: '00:30', text: '00:30'},
        {value: '01:00', text: '01:00'},
        {value: '01:30', text: '01:30'},
        {value: '02:00', text: '02:00'},
        {value: '02:30', text: '02:30'},
        {value: '03:00', text: '03:00'},
        {value: '03:30', text: '03:30'},
        {value: '04:00', text: '04:00'},
        {value: '04:30', text: '04:30'},
        {value: '05:00', text: '05:00'},
        {value: '05:30', text: '05:30'},
        {value: '06:00', text: '06:00'},
        {value: '06:30', text: '06:30'},
        {value: '07:00', text: '07:00'},
        {value: '07:30', text: '07:30'},
        {value: '08:00', text: '08:00'},
        {value: '08:30', text: '08:30'},
        {value: '09:00', text: '09:00'},
        {value: '09:30', text: '09:30'},
        {value: '10:00', text: '10:00'},
        {value: '10:30', text: '10:30'},
        {value: '11:00', text: '11:00'},
        {value: '11:30', text: '11:30'},
        {value: '12:00', text: '12:00'},
        {value: '12:30', text: '12:30'},
        {value: '13:00', text: '13:00'},
        {value: '13:30', text: '13:30'},
        {value: '14:00', text: '14:00'},
        {value: '14:30', text: '14:30'},
        {value: '15:00', text: '15:00'},
        {value: '15:30', text: '15:30'},
        {value: '16:00', text: '16:00'},
        {value: '16:30', text: '16:30'},
        {value: '17:00', text: '17:00'},
        {value: '17:30', text: '17:30'},
        {value: '18:00', text: '18:00'},
        {value: '18:30', text: '18:30'},
        {value: '19:00', text: '19:00'},
        {value: '19:30', text: '19:30'},
        {value: '20:00', text: '20:00'},
        {value: '20:30', text: '20:30'},
        {value: '21:00', text: '21:00'},
        {value: '21:30', text: '21:30'},
        {value: '22:00', text: '22:00'},
        {value: '22:30', text: '22:30'},
        {value: '23:00', text: '23:00'},
        {value: '23:30', text: '23:30'},
      ],
    }
  },
  mounted() {
    this.loadConditions();
  },
  methods: {
    loadConditions() {
      if (this.model['conditions'] && this.model['conditions'].length) {
        this.values = this.model['conditions']
      }
    },
    validate() {
      this.formErrors = [];
      if (!this.formModel.type) {
        this.formErrors.push({param: "type", msg: this.$t('check.notEmpty'), location: "body"});
      }
      if (!this.formModel.from) {
        this.formErrors.push({param: "from", msg: this.$t('check.notEmpty'), location: "body"});
      }
      if (!this.formModel.to) {
        this.formErrors.push({param: "to", msg: this.$t('check.notEmpty'), location: "body"});
      }
    },
    addCondition() {
      this.validate();
      if (this.formErrors.length > 0) {
        return false;
      }
      if (!this.model['conditions']) {
        this.model['conditions'] = []
      }
      this.model['conditions'].push(this.formModel);
      this.loadConditions();
      this.formModel = {
        type: null,
        from: null,
        to: null
      }
    },
    removeCondition(index) {
      if (this.model['conditions'] && this.model['conditions'].length) {
        this.model['conditions'].splice(index, 1)
      }
    },
    getType(type) {
      if (type === 'mon') {
        return this.$t('monCon')
      }
      return this.$t(type);
    }
  },
  watch: {
    "formModel.type": {
      handler() {
        this.formModel.from = null;
        this.formModel.to = null;
      }
    }
  },
  computed: {
    getOptions() {
      if (this.formModel.type === 'mon') {
        return this.monthOptions;
      }
      if (this.formModel.type === 'mday') {
        return this.mDayOptions;
      }
      if (this.formModel.type === 'wday') {
        return this.wDayOptions;
      }
      if (this.formModel.type === 'time-of-day') {
        return this.timeOfDayOptions;
      }
      return [{value: null, text: this.$t('chooseTypeFirst')}]
    },
    checkConditionCount() {
      if (this.errors.length) {
        let found = this.errors.find(f => f.param === 'conditions')
        return !!found;
      }
      return false
    }
  }
}
</script>